export interface RouteModel {
   baseUri: string
   title: string
   uri: string
   alt_uri: string
}

export const SITE_DIRECTORY_ROUTES = {
   auth: {
      title: 'Authentication Response',
      baseUri: 'auth',
      uri: 'auth'
   },
   b2cSusi: {
      title: '',
      baseUri: 'susi',
      uri: 'susi'
   },
   content: {
      faq: {
         title: 'FAQ',
         baseUri: 'faq',
         uri: 'faq'
      } as RouteModel,
      title: 'Courses',
      baseUri: 'courses',
      uri: 'courses'
   },
   completeRegistration: {
      title: 'Compete Registration',
      baseUri: 'complete-registration',
      uri: 'complete-registration'
   } as RouteModel,
   error: {
      title: 'Error Occurred',
      baseUri: 'error',
      uri: 'error'
   },
   loginFailed: {
      title: 'Login Failed',
      baseUri: 'login-failed',
      uri: 'login-failed'
   },
   member: {
      account: {
         profile: {
            title: 'Profile',
            baseUri: 'profile',
            uri: 'profile'
         } as RouteModel,
         title: 'Account',
         baseUri: 'account',
         uri: 'account'
      },
      setPassword: {
         title: 'Set Password',
         baseUri: 'set-password',
         uri: 'set-password'
      } as RouteModel,
      siteNotifications: {
         title: 'Notifications',
         baseUri: 'site-notifications',
         uri: 'site-notifications'
      } as RouteModel,
      title: 'Member Access',
      baseUri: 'member',
      uri: 'member'
   },
   pageNotFound: {
      title: '404: PAGE NOT FOUND',
      baseUri: '404',
      uri: '404'
   },
   registration: {
      title: 'Registration',
      baseUri: 'registration',
      uri: 'registration'
   },
   registrationLanding: {
      title: 'registration',
      baseUri: 'registration-landing',
      uri: 'registration-landing'
   },
   signUp: {
      title: 'Create Account',
      baseUri: 'sign-up',
      uri: 'sign-up'
   },
   unauthorized: {
      title: '401 UnAuthorized',
      baseUri: 'unauthorized',
      uri: 'unauthorized'
   },
   weHaveMoved: {
      title: 'We Have Moved',
      baseUri: 'we-have-moved',
      uri: 'we-have-moved'
   },
   title: 'College Entrance Advantage',
   baseUri: '',
   uri: '/'
}
